import { render, staticRenderFns } from "./PuestoPagoTarjetaRegas.vue?vue&type=template&id=16d33904"
import script from "./PuestoPagoTarjetaRegas.vue?vue&type=script&lang=js"
export * from "./PuestoPagoTarjetaRegas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports